<h2 mat-dialog-title cdkDrag cdkDragRootElement='.cdk-overlay-pane' cdkDragHandle>
  <span>
    <svg width='16px' fill='currentColor' viewBox='0 0 24 24'>
      <path
        d='M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z'></path>
      <path d='M0 0h24v24H0z' fill='none'></path>
    </svg>
  </span>
  Claim Submission
</h2>

<div mat-dialog-content>
  <!--  <dx-scroll-view [useNative]='true'>-->

  <ng-container *ngIf='lastClaim?.request'>
    <details>
      <summary>Submitted Claim Data</summary>

      <details style='padding-left: 1em;'>
        <summary>REQUEST</summary>
        <ngx-json-viewer [json]='lastClaim?.request || {}' [expanded]='false'></ngx-json-viewer>
      </details>

      <ng-container *ngIf='lastClaim?.response'>
        <details style='padding-left: 1em;'>
          <summary>RESPONSE</summary>
          <ngx-json-viewer [json]='lastClaim?.response || {}' [expanded]='false'></ngx-json-viewer>
        </details>
      </ng-container>
    </details>

    <br />
  </ng-container>

  <ng-container>
    <mat-radio-group [(ngModel)]='correctionType'>
      <mat-radio-button value='new'>Resubmit</mat-radio-button>
      <mat-radio-button value='adjust'>Adjust</mat-radio-button>
      <mat-radio-button value='void'>Void</mat-radio-button>
    </mat-radio-group>
  </ng-container>

  <dx-form
    #form
    [formData]='claimData'
    [disabled]='!claimData'
    (onFieldDataChanged)='onFieldDataChanged($event)'
  >
    <dxi-item
      *ngIf='correctionType === "adjust" || correctionType === "void"'
      dataField='correction.claimControlNumber'
    >
      <dxo-label text='Payer Claim ID'></dxo-label>
    </dxi-item>

    <dxi-item itemType='group' cssClass='form-group' [colCount]='2'>
      <dxi-item itemType='group'>
        <dxi-item
          dataField='payerID'
        >
          <!--            editorType='dxAutocomplete'-->
          <!--            [editorOptions]="{ dataSource: payerIDSource }"-->
          <dxo-label location='top' alignment='left' [text]='payerLabel'></dxo-label>
        </dxi-item>

        <dxi-item dataField='authID'>
          <dxo-label location='top' alignment='left' [text]='authLabel'></dxo-label>
        </dxi-item>

        <dxi-item
          dataField='procedureCode'
          [label]='{ location: "top", alignment: "left", text: "Code"}'
        >
          <!--          editorType='dxAutocomplete'-->
          <!--          [editorOptions]='{ readOnly: false, dataSource: procedureCodesSource }'-->
        </dxi-item>
      </dxi-item>

      <dxi-item itemType='group'>
        <dxi-item
          dataField='rate'
          editorType='dxNumberBox'
          [editorOptions]='{ showClearButton: true, showSpinButtons: true, min: 0 }'
        >
          <dxo-label location='top' alignment='left' text='Rate'></dxo-label>
        </dxi-item>

        <dxi-item
          dataField='chargeAmount'
          editorType='dxNumberBox'
          [editorOptions]='{ readOnly: true }'
        >
          <dxo-label location='top' alignment='left' text='Charge Amount'></dxo-label>
        </dxi-item>
      </dxi-item>
    </dxi-item>


    <dxi-item template="btnsTpl"></dxi-item>
    <div *dxTemplate="let data of 'btnsTpl'">
      <dx-button
        text="Build Lines From Auth"
        type="default"
        icon="add"
        (onClick)="buildAppointmentsFromAuth()"
      ></dx-button>

      &nbsp;

      <dx-button
        text="Cleanup All Service Lines"
        type="danger"
        stylingMode="outlined"
        icon="trash"
        (onClick)="cleanUp()"
      ></dx-button>
    </div>


    <dxi-item itemType="tabbed">
      <dxi-tab title="Scheduler" [template]="'tab2Content'"></dxi-tab>
      <!--      <dxi-tab title="Service Lines" [template]="'tab1Content'"></dxi-tab>-->
    </dxi-item>

    <div *dxTemplate="let data of 'tab2Content'">
      <dx-scheduler
        #claimScheduler
        width="100%"

        [views]="['month']"
        currentView="month"
        [dataSource]="appointments"

        dateSerializationFormat='yyyy-MM-dd'
        [currentDate]="minDate"
        [min]="minDate"
        [max]="maxDate"

        [firstDayOfWeek]="1"
        [startDayHour]="6"
        [endDayHour]="23"
        [showAllDayPanel]="false"

        appointmentTemplate="appointmentTemplate"
        dataCellTemplate="dataCellTemplate"

        (onCellClick)="scheduler_onCellClick($event)"
        (onAppointmentFormOpening)="scheduler_onAppointmentFormOpening($event)"

        (onAppointmentDblClick)="scheduler_onAppointmentDblClick($event)"
        (onAppointmentClick)="scheduler_onAppointmentClick($event)"

        (onAppointmentAdding)="scheduler_onAppointmentAdding($event)"
        (onAppointmentAdded)="scheduler_onAppointmentAdded($event)"
        (onAppointmentUpdated)="scheduler_onAppointmentUpdated($event)"
        (onAppointmentDeleted)="scheduler_onAppointmentDeleted($event)"
      >
        <dxo-editing
          [allowAdding]="true"
          [allowUpdating]="true"
          [allowDeleting]="true"
          [allowResizing]="false"
          [allowDragging]="false"
        ></dxo-editing>

        <ng-container *dxTemplate="let data of 'dataCellTemplate'">
          <div [ngClass]="{'dx-scheduler-data-cell-bg': cellHasAuth(data)}">
            <small style="opacity: 0.5" *ngIf="cellHasAuth(data)">{{ cellAuthUnits(data) }}</small> {{ data.text }}
          </div>

          <button
            *ngIf="cellHasApp(data)"
            mat-icon-button
            color="warn"
            (click)="removeAppointment($event, data)"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </ng-container>

        <ng-container *dxTemplate="let model of 'appointmentTemplate'">

          <dx-number-box
            class="service-line-units-box"
            stylingMode="filled"
            min="1"
            [(value)]="model.appointmentData.data.unitCount"
            [showSpinButtons]="true"
            [showClearButton]="true"
            (onValueChanged)="appointmentData_onValueChanged($event, model)"
          ></dx-number-box>

        </ng-container>

      </dx-scheduler>
    </div>

    <div *dxTemplate="let data of 'tab1Content'">

      <div *ngFor="let service of claimData?.services || []; let i = index">
        <dx-form
          #lineForm
          [formData]="service"
          (onFieldDataChanged)='service_onFieldDataChanged($event)'
        >
          <dxi-item itemType='group' cssClass='form-group' [colCount]='5'>

            <dxi-item
              dataField="serviceDate"
              editorType='dxDateBox'
              [label]='{ location: "top", alignment: "left", text: "Date"}'
              [editorOptions]="serviceLineDateOptions"
            ></dxi-item>

            <!--          <dxi-item-->
            <!--            dataField='serviceDateEnd'-->
            <!--            editorType='dxDateBox'-->
            <!--            [label]='{ location: "top", alignment: "left", text: "To" }'-->
            <!--            [editorOptions]="{ type: 'date', dateSerializationFormat: 'yyyy-MM-dd', displayFormat: 'shortDate' }"-->
            <!--          ></dxi-item>-->

            <dxi-item
              dataField='unitCount'
              editorType='dxNumberBox'
              [label]='{ location: "top", alignment: "left", text: "Units" }'
              [editorOptions]='{ showClearButton: true, showSpinButtons: true, min: 0 }'
            ></dxi-item>

            <dxi-item
              dataField='chargeAmount'
              editorType='dxNumberBox'
              [label]='{ location: "top", alignment: "left", text: "Charge Amount" }'
              [editorOptions]='{ readOnly: true }'
            ></dxi-item>

            <dxi-item
              horizontalAlignment="right"
              [label]='{ location: "top", alignment: "left", text: "&nbsp;", showColon: false }'
            >
              <dx-button
                text="Remove"
                type="danger"
                stylingMode="outlined"
                icon="trash"
                (onClick)="removeLineGroup(i)"
              ></dx-button>
            </dxi-item>

          </dxi-item>
        </dx-form>
      </div>

      <br>

      <dx-button
        text="Add Service Line"
        icon="add"
        type="default"
        (onClick)="addLineGroup()"
      ></dx-button>
    </div>

    <dxi-item
      itemType='group'
      cssClass='form-group'
      caption='Subscriber'
    >

      <dxi-item itemType='group' [colCount]='2'>
        <dxi-item itemType='group'>
          <dxi-item dataField='subscriber.memberID' [label]='{ text: "Member ID" }'></dxi-item>
          <dxi-item dataField='subscriber.firstname' [label]='{ text: "First Name" }'></dxi-item>
          <dxi-item dataField='subscriber.lastname' [label]='{ text: "Last Name" }'></dxi-item>
        </dxi-item>

        <dxi-item itemType='group'>
          <dxi-item itemType='empty'></dxi-item>
          <dxi-item dataField='subscriber.gender' [label]='{ text: "Gender" }'></dxi-item>
          <dxi-item
            dataField='subscriber.dob'
            editorType='dxDateBox'
            [label]='{ text: "DOB" }'
            [editorOptions]="{ type: 'date', dateSerializationFormat: 'yyyy-MM-dd', displayFormat: 'shortDate' }"
          ></dxi-item>

        </dxi-item>
      </dxi-item>

      <dxi-item itemType='group' caption='Address' [colCount]='2'>
        <dxi-item itemType='group'>
          <dxi-item dataField='address.address1'>
            <dxo-label text='Address1'></dxo-label>
          </dxi-item>

          <dxi-item dataField='address.address2'>
            <dxo-label text='Address2'></dxo-label>
          </dxi-item>

          <dxi-item dataField='address.city'>
            <dxo-label text='City'></dxo-label>
          </dxi-item>
        </dxi-item>

        <dxi-item itemType='group'>
          <dxi-item dataField='address.state'>
            <dxo-label text='State'></dxo-label>
          </dxi-item>

          <dxi-item dataField='address.zip'>
            <dxo-label text='Zip'></dxo-label>
          </dxi-item>
        </dxi-item>
      </dxi-item>

    </dxi-item>

  </dx-form>

  <pre *ngIf="config.isSU$ | async">{{ claimData | json }}</pre>

  <!--  </dx-scroll-view>-->
</div>

<div mat-dialog-actions>
  <button mat-button (click)="resetForm()">Reset</button>
  <button mat-button [mat-dialog-close]='false'>Cancel</button>
  <button mat-button color='primary' (click)='submit()'>Submit</button>
  <mat-checkbox *ngIf="config.isSU$ | async" [(ngModel)]='isTest'>Test Mode</mat-checkbox>
</div>
